import { Box, styled } from '@mui/material'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { FC, MouseEventHandler, ReactNode, useEffect, useState } from 'react'

interface Props {
  title: string
  children: ReactNode
  disableEventPropagation?: boolean
  duration?: number
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 14,
    padding: '10px 20px'
  }
}))

const ClickToShowToolTip: FC<Props> = ({
  title,
  children,
  disableEventPropagation = false,
  duration = 2000
}) => {
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleClick: MouseEventHandler<HTMLDivElement> = event => {
    if (disableEventPropagation) {
      event.stopPropagation()
    }

    setOpen(true)
  }

  useEffect(() => {
    if (open) {
      const t = setTimeout(() => {
        setOpen(false)
      }, duration)

      return () => {
        clearTimeout(t)
      }
    }
  }, [duration, open])

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Box>
        <StyledTooltip
          PopperProps={{
            disablePortal: true
          }}
          placement='top'
          arrow
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={title}
        >
          <Box onClick={handleClick}>{children}</Box>
        </StyledTooltip>
      </Box>
    </ClickAwayListener>
  )
}

export default ClickToShowToolTip
